import React from 'react';
import parse from 'html-react-parser';

export default function PageHeaderTitle({headerTitle}) {
  return headerTitle && (<h1 className="app-main-title">{parse(headerTitle)}</h1>);
}
